import {useEffect, useState} from 'react'
import {useSearchParams} from 'react-router-dom'
import {getRolsByUrl} from '../services/colaboradores'
import {getInfoRoute} from '../shared/functions'
import {useMyCompanies} from '../shared/hooks/useMyCompanies'

export const Redirect = () => {
  // AQUI MANEJAR OTROS CASOS DE REDIRECCION
  const {myCompanies, rolsByCompany} = useMyCompanies()

  const [searchParams] = useSearchParams()
  const companyId = searchParams.get('empresa') || ''
  const redirectTo = searchParams.get('redirectTo') || ''
  const [rols, setRols] = useState<string[]>([])
  const [error, setError] = useState<string | null>(null)
  // create localtion object from redirectTo
  const location = {
    pathname: redirectTo,
  }
  const route = getInfoRoute(location)
  const rolsAvailables = rolsByCompany.find((rol) => (rol.empresa as any) === companyId)?.rol ?? []
  // TENGA ACCESO A LA EMPRESA

  if (rols.length > 0) {
    if (myCompanies.includes(companyId)) {
      localStorage.setItem('selectedCompanyId', companyId)

      // VALIDAR QUE LA QUE PERFILES TIENEN ACCESO A LA URL y que el usuario tenga acceso a esos roles
      const hasRol = rolsAvailables.some((rol) => rols.includes(rol))
      // el primero que coincide
      const foundRol = rolsAvailables.find((rol) => rols.includes(rol))

      if (hasRol && foundRol && redirectTo) {
        window.localStorage.setItem('selectedRole', foundRol)
        window.location.replace(redirectTo)
      } else {
        console.log('ACC_ROLL_URI - Hubo un error al procesar la solicitud')
        // setError('ACC_ROLL_URI - Hubo un error al procesar la solicitud')
      }
    } else {
      console.log('UNAUTHORIZED - No tienes acceso a la empresa')
      // setError('UNAUTHORIZED - No tienes acceso a la empresa')
    }
  } else {
    console.log('RLS:0 - No se encontraron roles')
    // setError('RLS:0 - No se encontraron roles')
  }

  useEffect(() => {
    if (route.parentPath) {
      const parentPath = route.parentPath
      const path = route.path
      const formatRoute = `${parentPath}/${path}`
      getRolsByUrl(formatRoute ?? '')
        .then((res) => {
          if (res.success) {
            setRols(res.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [])

  // return error about not having access
  return null
}
